import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DashboardSection from './DashboardSection';
import { POLLING_CONFIG } from '../../config/polling';

// Minimalistic card style (Google-style) - now theme-aware
const minimalCard = {
  boxShadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  borderRadius: '8px',
  border: 1,
  borderColor: 'divider',
  transition: 'box-shadow 150ms ease',
  '&:hover': {
    boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px 0 rgb(0 0 0 / 0.06)'
  }
};

const OverviewPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      paddingTop: '6.25rem',
      paddingX: { xs: 2, sm: 3, md: 4 },
      minHeight: '100vh',
      maxWidth: '100%',
      overflowX: 'hidden'
    }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{
          color: 'text.primary',
          mb: 1,
          fontWeight: 400,
          fontSize: '2rem'
        }}>
          {t('providers:overview.title')}
        </Typography>
        <Typography variant="body1" sx={{
          color: 'text.secondary',
          fontSize: '1rem',
          lineHeight: 1.5
        }}>
          {t('providers:overview.description')}
        </Typography>
      </Box>

      {/* Dashboard mit Polling */}
      <DashboardSection
        pollingInterval={POLLING_CONFIG.DASHBOARD_INTERVAL}
        enablePolling={POLLING_CONFIG.ENABLE_POLLING}
      />

    </Box>
  );
};

export default OverviewPage;
